import { z } from "zod";

export const PaginationSchema = z.object({
  total: z.number(),
  page: z.number(),
  totalPages: z.number(),
  limit: z.number(),
  nextPage: z.number().nullable(),
  prevPage: z.number().nullable(),
});
